module.exports = __webpack_public_path__ + "img/clarna.62a00559.svg";